import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries';

const ListaMon = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="moneda" id="miLista1" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Pesos</option>
        <option>Dolares</option>
        <option>Euros</option>
      </select>
    </div>
  )
};
const DetalleNivel4 = props => {
  return (
    <option dato1={props.elemento.observacionesOC?props.elemento.observacionesOC:''} value={props.elemento.numCoti}>{props.elemento.numCoti}</option>

  )
};

const ListaSol = ({list3, handleLista3}) => {
  const Nivel4Detalle = list3.map((elemento, _id) => <DetalleNivel4 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="numSolic" id="miLista3" onChange={handleLista3}>
        <option value="">Seleccionar...</option>
        {Nivel4Detalle}
      </select>
    </div>
  )
};

const DetalleNivel1 = props => {
  let canti=""
  if(props.elemento.cantidadCoti){
    canti = " ( " + props.elemento.cantidadCoti + " )"
  }
  return (
    <option dato1={props.elemento.tipoProducto} dato2={props.elemento.descrProducto} dato3={props.elemento.numOrdenCompraCli?props.elemento.numOrdenCompraCli:0} dato4={props.elemento.cantidadOC?props.elemento.cantidadOC:0} value={props.elemento.descrProducto}>{props.elemento.descrProducto}{canti}</option>

  )
};

const ListaPro = ({list, handleLista}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrProducto" id="miLista4" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const DetalleNivel2 = props => {
  return (
    <option dato1={props.elemento.abrevUnidad} value={props.elemento.descrUnidad}>{props.elemento.descrUnidad}</option>

  )
};

const ListaUni = ({list, handleLista1}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrUnidad" id="miLista8" onChange={handleLista1}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const DetalleNivel3 = props => {
  return (
    <option dato1={props.elemento.ciudad?props.elemento.ciudad:""} dato2={props.elemento.direccion?props.elemento.direccion:""} dato3={props.elemento.telefono?props.elemento.telefono:""} dato4={props.elemento.email?props.elemento.email:""} dato5={props.elemento.numeroDocumento?props.elemento.numeroDocumento:""} dato6={props.elemento.contacto?props.elemento.contacto:""} value={props.elemento.descrProveed}>{props.elemento.descrProveed}</option>

  )
};

const ListaProve = ({list, handleLista2}) => {
  const Nivel3Detalle = list.map((elemento, _id) => <DetalleNivel3 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrProveed" id="miLista6" onChange={handleLista2}>
        <option value="">Seleccionar...</option>
        {Nivel3Detalle}
      </select>
    </div>
  )
};



  class AddCotizacionProve2 extends React.Component{
    state={argsAdd: {}, listaItem2: this.props.allProveed.allProveed}

  handleChange = async (ev) => {
    const argsAdd = this.state.argsAdd
    this.setState({argsAdd})
  }

  render(){
    const {argsAdd} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let args = Object.assign({}, this.props.args, argsAdd)
    let list = []
    if(this.props.allCotizacionProRtes.allCotizacionRtes){list = this.props.allCotizacionProRtes.allCotizacionRtes}
    let listPr=[]
    if (args.numSolic){
      let numCoti=args.numSolic
      listPr = list.filter(elemento => elemento.numCoti===numCoti)
    }  
    let listProve=this.state.listaItem2
    console.log(listProve)
    let buscItem = ''
    if(args.descrProveedB){
      buscItem = args.descrProveedB
    }
    if(buscItem){
      listProve = listProve.filter(elemento => elemento.descrProveed.toLowerCase().indexOf(buscItem.toLowerCase()) > -1)
    }
    console.log(this.props.list3)
    return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Item nuevo
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, args)}>
        <div className="ui four column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '20%'}}>                
                <Form.Field>
                  <div className="ui input fluid">
                    <input id='descrProveedB' autoComplete="off" name="descrProveedB" type="text" placeholder="Buscar Proveedor" style={this.props.styles.dropdown} onChange={this.props.handleChange}/>
                  </div>
                </Form.Field>    
              </div>
            </div>
            <div className="row container">
              <div className="column" width="20%">
                <Form.Field>
                  <label style={this.props.styles.label}>Proveedor</label>
                  <ListaProve list={listProve} handleLista2={this.props.handleLista2} />
                </Form.Field>  
              </div>
              <div className="column" width="50%">                
                <Form.Field>
                  <label style={this.props.styles.label}>Solicitud de compra</label>
                  <ListaSol list3={this.props.list3} handleLista3={this.props.handleLista3} />
                </Form.Field>    
              </div>
              
              <div className="column" width="10%">  
                <Form.Field>
                    <label style={this.props.styles.label}># Cotización</label>
                    <Form.Input autoComplete="off" name="numCoti" id="numCoti" onChange={this.props.handleChange} placeholder='# Cotización' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'numCoti'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>  
              </div>
              <div className="column" width="20%">                
                <Form.Field>
                  <label style={this.props.styles.label}>Material/Equipo</label>
                  <ListaPro list={listPr} handleLista={this.props.handleLista} />
                </Form.Field>     
              </div>
            </div>
          </div>
          <div className="ui six column stackable grid">
            <div className="row container">
              <div className="column" width="10%">
                <Form.Field>
                  <label style={this.props.styles.label}>Cantidad</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="cantidadCoti" id="cantidadCoti" placeholder='Cantidad' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" width="10%">                
                <Form.Field>
                  <label style={this.props.styles.label}>Unidad</label>
                  <ListaUni list={this.props.listUni} handleLista1={this.props.handleLista1} />
                </Form.Field>    
              </div>
              <div className="column" width="10%">
                <Form.Field>
                  <label style={this.props.styles.label}>Valor Und</label>
                  <input type='number' step="0.01" min="0" autoComplete="off" name="valorUniCoti" id="valorUniCoti" placeholder='Valor Und' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" width="10%">
                <Form.Field>
                  <label style={this.props.styles.label}>Moneda</label>
                  <ListaMon styles={this.props.styles} handleLista={this.props.handleLista4} />
                </Form.Field>
              </div>              
              <div className="column" width="10%">
                <Form.Field>
                  <label style={this.props.styles.label}>% Descuento</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="porcDcto" id="porcDcto" placeholder='% Descuento' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" width="10%">
                <Form.Field>
                  <label style={this.props.styles.label}>% IVA</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="porcIVA" id="porcIVA" placeholder='% IVA' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
            </div>
          </div>

          <div className="row container">
            <div className="column" width="100%">                
              <Button style={this.props.styles.confirmar} type='submit' fluid>
                AGREGAR
              </Button>
            </div>
            {
              this.props.errors.length?<Message negative header="Los siguientes errores:"
              list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }
          </div>
        </Form>
      </div>
    </div>
  )
  }
}

// export default AddProcEjec2
export default compose(
  graphql(queries.query.allProveed, {name:'allProveed'}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionProRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', estadoCoti: 'Aprobada', tipo: 'Solicitud'}},
    {"$unwind": "$itemsCoti"},
    {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, numCoti: 1, 
      tipo: 1, tipoCoti: 1, estadoCoti: 1, descrProducto: '$itemsCoti.descrProducto', cantidadCoti: '$itemsCoti.cantidadCoti', 
      tipoProducto: '$itemsCoti.tipoProducto', numOrdenCompraCli: '$itemsCoti.numOrdenCompraCli', cantidadOC: '$itemsCoti.cantidadOC'}},   
      {$sort: {descrProducto: 1}}
    ]`}}}}),

  )(AddCotizacionProve2)